export const BASE_INTL_ID = 'self-serve-sign-up.onboarding-page';
export const BASE_STEPS_PREVIEW_INTL_ID = `${BASE_INTL_ID}.stages-view`;
